// Contains custom data for our differential amplifiers.
// This file is used to define irregular data, particularly for fixed / programmable gain differential amplifiers or the differential amplifiers used inside our uModules

export let data = {
    "map": {
        "LTC6363-0.5": "LTC6363-0.5",
        "LTC6363-1": "LTC6363-1",
        "LTC6363-2": "LTC6363-2",
        "AD8475" : "AD8475",
        "AD8476" : "AD8476",
        "ADAQ400X_ADC_DRIVER_FP" : "ADAQ400X_ADC_DRIVER_FP",
        "ADAQ400X_ADC_DRIVER_LP" : "ADAQ400X_ADC_DRIVER_LP",
        "ADAQ2387X_ADC_DRIVER" : "ADAQ2387X_ADC_DRIVER",
        "ADAQ4380_ADC_DRIVER_FP" : "ADAQ4380_ADC_DRIVER_FP",
        "ADAQ4380_ADC_DRIVER_LP" : "ADAQ4380_ADC_DRIVER_LP",
    },
    "partData": {
        "LTC6363-0.5": {
            rF: 0.7e3,
            rG: 1.4e3,
            cF: 4e-12,
            differentialAmp: {
                partName: 'LTC6363',
                gainError: 0.0045,
                gainErrorAtMaxTemp: 0.0075,
                gainTC: 0.5, 
                cmrr: 94,
            },
            requiredPDBParameters: []
        },
        "LTC6363-1": {
            rF: 1.05e3,
            rG: 1.05e3,
            cF: 2.9e-12,
            differentialAmp: {
                partName: 'LTC6363',
                gainError: 0.0045,
                gainErrorAtMaxTemp: 0.0075,
                gainTC: 0.5, 
                cmrr: 94,
            },
            requiredPDBParameters: []
        },
        "LTC6363-2": {
            rF: 1.4e3,
            rG: 0.7e3,
            cF: 5.8e-12,
            differentialAmp: {
                partName: 'LTC6363',
                gainError: 0.0045,
                gainErrorAtMaxTemp: 0.0075,
                gainTC: 0.5, 
                cmrr: 94,
            },
            requiredPDBParameters: []
        },
        "AD8475": {
            "gains (V/V)" : [
                "0.4",
                "0.8"
            ],
            "0.4": {
                rF: 1e3,
                rG: 2.5e3,
                cF: 0.9e-12,
            },
            "0.8": {
                rF: 1e3,
                rG: 1.25e3,
                cF: 0.9e-12,
            },
            differentialAmp: {
                partName: 'AD8475-INT',
                // Useful PDB parameters, since internal amp is not in PDB database
                gbw: 240e6,
                gbwCm: 10e6, 
                rInVocm: 100e3,   
                rDiff: 50e3, 
                rCm: 5e6, 
                cDiff: 1e-20,
                cCm: 1e-20,
                rOut: 50,  //SIM-629
                vNoise: 6.48e-9,
                /* The AD8475 datasheet doesn't specify any value for the VOCM noise of the part, so we choose a conservative value based on similar FDA's. 
                However, since the resistors around AD8475's internal FDA are symmetric (balanced), the noise contribution of the VOCM noise is zero anyway.*/
                vNoiseVocm: 40e-9, 
                slewRate: 50e6,
                gainError: 0.02,
                gainTC: 3, 
                cmrr: 86,
                outHeadroomVminusTyp: 0.05,
                outHeadroomVplusTyp: 0.05,
                inHeadroomVminusMax: 0,
                inHeadroomVplusMax: 1,
                supplyCurrentTyp: 3e-3,
                supplyCurrentMax: 3.2e-3,
            },
            // No PDB or TPC parameters required for the full AD8475 - parameters will come from AD8475-INT
            requiredPDBParameters: [],
            requiredTPCParameters: [],     
        },
        "AD8476": {
            rF: 10e3,
            rG: 10e3,
            cF: 1e-15,
            differentialAmp: {
                partName: 'AD8476-INT',
                // Useful PDB parameters, since internal amp is not in PDB database
                gbw: 9.5e6,
                gbwCm: 1e6, 
                rInVocm: 500e3, 
                cDiff: 0.4e-12, 
                cCm: 1e-20, 
                rDiff: 500e3, 
                rCm: 50e6, 
                vNoise: 1.56e-8,
                rOut: 100, //SIM-629
                /* The AD8476 datasheet doesn't specify any value for the VOCM noise of the part, so we choose a conservative value based on similar FDA's. 
                However, since the resistors around AD8476's internal FDA are symmetric (balanced), the noise contribution of the VOCM noise is zero anyway.*/
                vNoiseVocm: 50e-9, 
                slewRate: 10e6,
                gainError: 0.02,
                gainTC: 1, 
                cmrr: 90,  
                outHeadroomVminusTyp: 0.05,
                outHeadroomVplusTyp: 0.05,
                inHeadroomVminusMax: 0,
                inHeadroomVplusMax: 1,
                supplyCurrentTyp: 330e-6,
                supplyCurrentMax: 500e-6,
            },
            // No PDB or TPC parameters required for the full AD8476 - parameters will come from AD8476-INT
            requiredPDBParameters: [],
            requiredTPCParameters: [],     
        },
        // This is not a stand alone part - it's the driver inside the ADAQ400X family of uModules.  This driver uses the ADA4945-1, but since the ADAQ400X includes internal
        // resistors we will model this part as a programmable gain part (like the AD8475). This section models the ADA4945 at full power. Same passives
        // as ADAQ400X_ADC_DRIVER_LP.
        "ADAQ400X_ADC_DRIVER_FP": {
            "gains (V/V)" : [
                "0.454",
                "0.909",
                "1",
                "1.9"
            ],
            "0.454": {
                rF: 500,
                rG: 1.1e3,
                cF: 19e-12,
            },
            "0.909": {
                rF: 1e3,
                rG: 1.1e3,
                cF: 19e-12,
            },
            "1": {
                rF: 1e3,
                rG: 1e3,
                cF: 19e-12,
            },
            "1.9": {
                rF: 1e3,
                rG: 524,
                cF: 19e-12,
            },
            differentialAmp: {
                partName: 'ADA4945-1 full power',
                cDiff: 105e-12,
                rInVocm: 1e12,
            },
            requiredPDBParameters: [],  
        },
        // This is not a stand alone part - it's the driver inside the ADAQ400X family of uModules.  This driver uses the ADA4945-1, but since the ADAQ400X includes internal
        // resistors we will model this part as a programmable gain part (like the AD8475). This section models the ADA4945 at low power.  Same passives
        // as ADAQ400X_ADC_DRIVER_FP.
        "ADAQ400X_ADC_DRIVER_LP": {
            "gains (V/V)" : [
                "0.454",
                "0.909",
                "1",
                "1.9"
            ],
            "0.454": {
                rF: 500,
                rG: 1.1e3,
                // cF: 19e-12,
                cF: 29e-12,
            },
            "0.909": {
                rF: 1e3,
                rG: 1.1e3,
                cF: 19e-12,
            },
            "1": {
                rF: 1e3,
                rG: 1e3,
                cF: 19e-12,
            },
            "1.9": {
                rF: 1e3,
                rG: 524,
                cF: 19e-12,
            },
            differentialAmp: {
                partName: 'ADA4945-1 low power',
                cDiff: 105e-12,
                rInVocm: 1e12,
            },
            requiredPDBParameters: [],  
        },
        // This is not a stand alone part - it's the driver inside the ADAQ2387X family of uModules.  This driver uses the ADA4945-1 (always at full power), 
        // but since the ADAQ2387X includes internal resistors we will model this part as a programmable gain part (like the AD8475). 
        "ADAQ2387X_ADC_DRIVER": {
            "gains (V/V)" : [
                "0.37",
                "0.73",
                "0.87",
                "1.38",
                "2.25",
                "2"
            ],
            "0.37": {
                rF: 578.9,
                rG: 1571.4,
                cF: 2.6e-12,
            },
            "0.73": {
                rF: 733.3,
                rG: 1000,
                cF: 2.6e-12,
            },
            "0.87": {
                rF: 1375,
                rG: 1571.4,
                // cF was originally 2.6pF, but changed to 2.3pF to tweak our model to match datasheet better
                cF: 2.3e-12,
            },
            "1.38": {
                rF: 1375,
                rG: 1000,
                cF: 2.6e-12,
            },
            "2.25": {
                rF: 1375,
                rG: 611.1,
                // cF was originally 2.6pF, but changed to 3.3pF to tweak our model to match datasheet better
                cF: 3.3e-12,
            },
            // The gain of 2 below is only applicable to the ADAQ23875.
            "2": {
                rF: 1100,
                rG: 550,
                // cF was originally 1.3pF, but changed to 3.2pF to tweak our model to match datasheet better
                cF: 3.2e-12,
            },
            differentialAmp: {
                partName: 'ADA4945-1 full power',
                cDiff: 3.3e-12/2,
                rInVocm: 1e12,
                vocmHeadroomVminusTyp: 0,
                vocmHeadroomVplusTyp : 0.9
            },
            requiredPDBParameters: [],  
        },
        // This is not a stand alone part - it's the driver inside the ADAQ4380-4 uModule.  This driver uses the ADA4945-1, but since the ADAQ4380-4 includes internal
        // resistors we will model this part as a programmable gain part (like the AD8475). This section models the ADA4945 at full power. Same passives
        // as ADAQ4380_ADC_DRIVER_LP.
        "ADAQ4380_ADC_DRIVER_FP": {
            "gains (V/V)" : [
                "0.3",
                "0.6",
                "1",
                "1.6"
            ],
            "0.3": {
                rF: 810,
                rG: 2.7e3,
                cF: 15e-12,
            },
            "0.6": {
                rF: 1.62e3,
                rG: 2.7e3,
                cF: 15e-12,
            },
            "1": {
                rF: 1.62e3,
                rG: 1.62e3,
                cF: 15e-12,
            },
            "1.6": {
                rF: 1.62e3,
                rG: 1.0125e3,
                cF: 15e-12,
            },
            differentialAmp: {
                partName: 'ADA4945-1 full power',
                cDiff: 15e-12/2,//best estimate now, to be measured later
                rInVocm: 1e12,
            },
            requiredPDBParameters: [],  
        },
        // This is not a stand alone part - it's the driver inside the ADAQ4380-4 uModule.  This driver uses the ADA4945-1, but since the ADAQ4380-4 includes internal
        // resistors we will model this part as a programmable gain part (like the AD8475). This section models the ADA4945 at low power. Same passives
        // as ADAQ4380_ADC_DRIVER_FP.
        "ADAQ4380_ADC_DRIVER_LP": {
            "gains (V/V)" : [
                "0.3",
                "0.6",
                "1",
                "1.6"
            ],
            "0.3": {
                rF: 810,
                rG: 2.7e3,
                cF: 15e-12,
            },
            "0.6": {
                rF: 1.62e3,
                rG: 2.7e3,
                cF: 15e-12,
            },
            "1": {
                rF: 1.62e3,
                rG: 1.62e3,
                cF: 15e-12,
            },
            "1.6": {
                rF: 1.62e3,
                rG: 1.0125e3,
                cF: 15e-12,
            },
            differentialAmp: {
                partName: 'ADA4945-1 low power',
                cDiff: 15e-12/2,//best estimate now, to be measured later
                rInVocm: 1e12,
            },
            requiredPDBParameters: [],  
        },
    }
}